module.exports = __webpack_public_path__ + "finance-en.b13632b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/tables/FinanceTable/images/finance-en.png
// module id = 67k3
// module chunks = 0